import Gosia_Lewczuk_Img from '@/assets/images/Gosia_Lewczuk.jpg';
import Marta_Palinska_Img from '@/assets/images/Marta_Palinska.jpg';
import Pawel_Korzeniowski_Img from '@/assets/images/Pawel_Korzeniowski.jpg';

import dish_1 from '@/assets/images/slider_recipes/1.jpg';
import dish_2 from '@/assets/images/slider_recipes/2.jpg';
import dish_3 from '@/assets/images/slider_recipes/3.jpg';
import dish_4 from '@/assets/images/slider_recipes/4.jpg';
import dish_5 from '@/assets/images/slider_recipes/5.jpg';
import dish_6 from '@/assets/images/slider_recipes/6.jpg';
import dish_7 from '@/assets/images/slider_recipes/7.jpg';

import protest_1 from '@/assets/images/slider_protest/1.jpg';
import protest_2 from '@/assets/images/slider_protest/2.jpg';
import protest_3 from '@/assets/images/slider_protest/3.jpg';
import protest_4 from '@/assets/images/slider_protest/4.jpg';

import maonifestoDeskImg from '@/assets/images/manifest.svg';
import maonifestoMobImg from '@/assets/images/manifest_mob.svg';



export default {
    "intro": {
        "visible": true,
        "header": "REWOLUCYJNA KSIĄŻKA KUCHARSKA, CZYLI PRZEPISY NA LEPSZĄ POLSKĘ",
        "intro": "Nasz świat potrzebuje zmiany - a ta może zacząć się od rozmowy przy wspólnym stole. “Rewolucyjna książka kucharska…” to przepisy na lepszą Polskę i na roślinne posiłki, dające siłę do działania na rzecz zmiany.",
        "content": "Wyobraź sobie Polskę, w której ludzie i przyroda żyją w harmonii, mają zapewnione bezpieczeństwo i warunki do rozwoju. Kraj, w którym zamiast ciągłej pogoni za wzrostem, skupiamy się na regeneracji. Chcemy, aby ta wizja zmieniła się w rzeczywistość.",
        "content_2": "Rewolucyjna książką kucharska…” to coś więcej niż tylko książka. To idee, które mogą odmienić naszą przyszłość. Dołącz do grona osób współtworzących lepszą Polskę i bądź częścią tej historii. ",
        "counters_1": {"number": 19, "text": "inspirujących rozmów"},
        "counters_2": {"number": 119, "text": "osób współtworzących książkę"},
        "counters_3": {"number": 69, "text": "roślinnych przepisów"}

    },
    "book_in_hand": {
        "visible": true,
    },
    "manifesto": {
        "visible": true,
        "header": "Nadchodzi zmiana",
        "btn": "W co wierzymy?",
        "img_desk": maonifestoDeskImg,
        "img_mob": maonifestoMobImg,
    },
    "authors": {
        "visible": true,
        "header": "",
        "intro": "“Rewolucyjna książka kucharska…” to 19 przepisów na lepszą Polskę, które sporządziliśmy wraz z osobami ze świata nauki i aktywizmu, które swoją postawą  już teraz działają na rzecz zmiany. To rozmowy o lepszej przyszłości, marzeniach i inspiracjach, które mogą doprowadzić do ważnych przemian. Znajdziecie w nich odważne idee, ambitne rozwiązania, a przede wszystkim nadzieję.",
        "content": "Swoje przepisy na lepszą Polskę dali nam:",
        "names": ["Tomasz Markiewka","Wojtek Sawicki","Jarosław Niemiec","Joanna Erbel", "Janina Bąk", "Jan Zygmuntowski", "Weronika Parfianowicz", "Ewa Bińczyk", "Maciej Mandelt", "Ane Piżl", "Oliwia Bosomtwe", "Jakub Rok", "Paulina Kramarz", "Jana Shostak", "Bart Staszewski", "Lu Gaszyński", "Marcel Andino Velez", "Agnieszka Graff"," Paulina Bownik" ]
    },
    "fragments": {
        "visible": true,
        "header": "Stań się częścią rewolucji - współtwórz ją razem z&nbspnami!",
        "intro": "Do współtworzenia książki zaprosiliśmy osoby, które które mają w sobie niezgodę na obecny stan rzeczy, ale też nadzieję i pomysły na zmiany. Szukaliśmy przepisów na to, jak lepiej i bezpieczniej dla ludzi i przyrody wytwarzać żywność, jak zadbać o równość i prawa człowieka, jak usprawnić dostęp do usług publicznych i właściwej opieki, w tym opieki medycznej, jak uniezależnić się od paliw kopalnych, jak dbać o relacje społeczne, ale i te z otaczającą nas przyrodą, a także jak skutecznie i bezpiecznie działać na rzecz zmiany - zarówno indywidualnie, jak i organizując się w grupy i ruchy.<br/>Chcemy, aby te wyjątkowe rozmowy zostały nie tylko na kartkach książki, ale żeby inspirowały do działania. Chcemy podzielić się nimi z całą Polską - upowszechniać je, podejmować wspólnie działania i doprowadzić do tego, żeby lepsza przyszłość opierała się na trosce o ludzi i przyrodę, na solidarności, bezpieczeństwie i regeneracji.",
        "content": "Chcesz poznać przepisy na lepszą Polskę, a jednocześnie zasmakować pysznej kuchni roślinnej? Wesprzyj powstanie “Rewolucyjnej książki kucharskiej…” i realizację stojących za nią idei, a otrzymasz swój egzemplarz, jak tylko wyjdzie z drukarni.",
        "btn": "Zamów książkę!"
    },
    "dishes": {
        "visible": true,
        "header": "REWOLUCYJNA KSIĄŻKA KUCHARSKA TO TEŻ PRZEPISY NA PYSZNE ROŚLINNE DANIA",
        "intro": "Znajdziesz w niej kilkadziesiąt przepisów na wegańskie dania z lokalnych składników. Swoimi ulubionymi przepisami podzieliły się z nami osoby z całej Polski, ale także członkinie i członkowie Słusznej Strawy - spółdzielni współtworzonej przez osoby z doświadczeniem migracji i wspierającej osoby uchodźcze. Każdy przepis został przez nas wypróbowany, sfotografowany i opisany tak, aby każdy bez problemu poradził sobie nawet z lepieniem pierogów!<br/><br/>Rewolucyjna książka kucharska to kulinarna podróż po wegańskiej Polsce i nie tylko! ",
        "slides":[ {
            "text": "Wegańska carbonara z sosem z ziemniaka i boczkiem z korzenia pietruszki",
            "img": dish_1,
        },{
            "text": "Kruche ciastka z jabłkami",
            "img": dish_2,
        },
        {
            "text": "Aromatyczny rosół",
            "img": dish_3,
        },
        {
            "text": "Lasagne alla Frankie",
            "img": dish_4,
        },
        {
            "text": "Kartacze z soczewicą, czyli podlaski klasyk z roślinnym twistem",
            "img": dish_5,
        },
        {
            "text": "Hiszpańska botwina z ziemniakami",
            "img": dish_6,
        },
        {
            "text": "\"Śledź\" z bakłażana - doskonały na święta i nie tylko",
            "img": dish_7,
        }
    ]
    },
    "how": {
        "visible": true,
        "header": "Jak zdobyć książkę?",
        "intro": "“Rewolucyjna książka kucharska…” to coś więcej niż tylko książka - to zbiór idei, które chcemy realizować wspólnie z Wami. Książkę otrzyma każda osoba, która zdecyduje się na wspieranie nie tylko jej wydania, ale i realizacji zawartych w niej wizji lepszej Polski i dołączy do grona Darczynek i Darczyńców Greenpeace. <b>Nie będzie jej w księgarniach.</b> To dzięki cyklicznemu wsparciu tysięcy wspaniałych osób jesteśmy w stanie działać i zmieniać świat. Wesprzyj nas, odbierz książkę i stań się częścią rewolucji! To wsparcie to “abonament” na lepszą przyszłość!",
        "content__1_0": "Co zawiera książka?",
        "content__1_1": "19 rozmów",
        "content__1_2": "69 wegańskich przepisów",
        "content__1_3": "27 zdjęć inspirujących do działania ",
        "content__2_0": "Kiedy ją otrzymam?",
        "content__2_1": "Jeśli zdecydujesz się na wspieranie wydania książki i zawartych w niej idei już dziś, otrzymasz ją jeszcze przed świętami. To doskonała okazja, aby podarować ją wyjątkowej osobie. ",  
        "content__3_0": "Czy oprócz książki otrzymam coś jeszcze?",
        "content__3_1": "Tak! Jeśli zdecydujesz się na wspieranie projektu kwotą powyżej 60 zł miesięcznie, otrzymasz od nas wyjątkowy plakat zaprojektowany przez Olę Jasionowską, Martę Frej lub Patryka Hardzieja (Ty wybierasz!). Świetnie sprawdzi się zarówno na ścianie, jak i podczas protestów! ",
        "btn": "Zamów już dziś!"
    },
    "protests": {
        "visible": true,
        "header": "Co nowego",
        "intro": "",
        "content": "Doświadczamy kumulujących się kryzysów klimatycznego i ekologicznego, rosnących nierówności i kosztów życia. Przed nami kolejne wyzwania. Żeby im sprostać, potrzebujemy zmian. Potrzebujemy pomysłów na Polskę, w której zaspokajamy nasze potrzeby bez niszczenia przyrody. Na Polskę zieloną, pokojową i taką, w której troszczymy się o siebie.",
        "content_1": "Czujesz potrzebę zmian? Szukasz nadziei? Chcesz działać na rzecz klimatu i sprawiedliwego społeczeństwa i szukasz na to… przepisów?",
        "content_2": "Pogadajmy o lepszej Polsce przy lepszym jedzeniu. Zapraszamy do wspólnego stołu!",
        "gallery":[ protest_1, protest_2, protest_3, protest_4]
    },
    "faq": {
        "visible": true,
        "header": "FAQ",
        "accordeon": [{
            "question": "Czy książkę będzie można kupić w księgarniach?",
            "answer": "Nie, książka dostępna jest wyłącznie na stronie rewolucyjna.pl - książkę otrzyma każda osoba, która zdecyduje się na wspieranie nie tylko jej wydania, ale i realizacji zawartych w niej wizji lepszej Polski i dołączy do grona Darczynek i Darczyńców Greenpeace."
        },
        {
            "question": "Kiedy dostanę książkę?",
            "answer": "Książka będzie gotowa w grudniu tego roku! Jeśli zaczniesz wspierać projekt i zamówisz ją do końca listopada - dotrze do Ciebie przed świętami."
        },
        {
            "question": "Co jeżeli już jestem regularnym darczyńcą/darczynką Greenpeace?",
            "answer": "Skontaktuj się z nami! Wyślij wiadomość na adres <a href='mailto:spl@greenpeace.org'>spl@greenpeace.org</a>"
        },
        {
            "question": "Na co zostaną przeznaczone moje pieniądze?",
            "answer": "Twoje wsparcie finansowe zostanie przeznaczone na wydanie książki, promowanie jej założeń i realizowanie jej postulatów. Zarówno przez Greenpeace Polska jak i wspierane przez nas inicjatywy."
        },
        {
            "question": "Dlaczego to wegańska książka kucharska?",
            "answer": "Przepisy są wegańskie i z lokalnych produktów, bo chcemy wspierać dobre nawyki. Wytwarzanie roślinnej żywności to mniejsza presja na środowisko i klimat, dobrostan zwierząt i zdrowie ludzi! "
        },
        {
            "question": "Dlaczego płatności można dokonać tylko w PayU i PayPal?",
            "answer": "To jedni z najbardziej zaufanych operatorów płatności internetowych, z których usług z powodzeniem korzystają miliony osób. PayU i PayPal zapewniają bardzo wysoki standard bezpieczeństwa transakcji, a jednocześnie obsługują płatności elektroniczne większości banków i kart płatniczych w Polsce"
        },
        {
            "question": "Co to znaczy, że wspieram projekt regularnie?",
            "answer": "Oznacza to, że system będzie automatycznie, co miesiąc, pobierał z Twojej karty lub konta PayPal wskazaną kwotę. To rodzaj “abonamentu” na wsparcie książki i realizację zawartych w niej wizji. Wystarczy, że za pomocą bezpiecznego systemu płatności PayU lub PayPal podasz numer swojej karty kredytowej lub płatniczej lub zalogujesz się na swoje konto PayPal i określisz wysokość wsparcia. To mechanizm podobny do tego, który możesz znać z popularnych serwisów oferujących np. filmy lub muzykę online, za które co miesiąc opłacany jest abonament. PayU i PayPal to doświadczeni i bezpieczni operatorzy płatności internetowych. W każdej chwili możesz też zmienić wysokość wsparcia lub je zawiesić, jeśli w danym momencie nie będziesz w stanie wpłacić określonej kwoty. Greenpeace jest niezależną organizacją, która nie przyjmuje pieniędzy od firm ani rządów, dlatego tak ważne jest regularne wsparcie od osób takich jak Ty."
        },
        {
            "question": "Czy mogę wspierać regularnie, jeśli nie mam karty płatniczej?",
            "answer": "Tak - w systemie PayPal. Wystarczy, że zasilisz swoje konto w dowolny sposób dostępny na tej platformie. Podanie numeru karty płatniczej (kredytowej lub debetowej) jest wymagane tylko w systemie PayU. Niestety w tej chwili nie ma możliwości wsparcia regularnego za pomocą przelewów bankowych. W razie dodatkowych pytań napisz na adres <a href='mailto:spl@greenpeace.org'>spl@greenpeace.org</a>"
        }
    ]
     
    },
    "contributors": {
        "visible": true,
        "header": "KSIĄŻKĘ WSPÓŁTWORZĄ SUPER OSOBY!",
        "intro": "“Rewolucyjną książka kucharska…” powstaje dzięki zaangażowaniu ekipy kilkunastu wspaniałych osób, poznaj kilka z nich:",
        "content": "Książka nie mogłaby też powstać bez Olgi Gitkiewicz, Bogu Gojdź, Pauliny Grudy, Marianny Hoszowskiej, Olgi Kamińskiej, Michała Sochackiego, Pawła Szypulskiego, Dominika Zgódki, Stefana Zgódki i Maxa Zielińskiego.",
        "people": [{
            "img": Marta_Palinska_Img,
            "name": "Marta Palińska",
            "desc": "aktywistka, specjalistka ds. komunikacji w Greenpeace Polska. Jest merytorycznym sercem naszej publikacji, współautorką rozmów. "
        },
        {
            "img":Pawel_Korzeniowski_Img ,
            "name": "Paweł Korzeniowski",
            "desc": "dziennikarz, pisze o ekologii i społeczeństwie, w naszej książce współprowadzi rozmowy."
        },
        {
            "img": Gosia_Lewczuk_Img,
            "name": "Gosia Lewczuk",
            "desc": "wykarmiła setki osób aktywistycznych przy dziesiątkach okazji. Miłośniczka kuchni, poszukująca tradycyjnych, jak i nowych smaków w wersji wegańskiej. Jest autorką wielu przepisów i opiekunką całej kulinarnej części naszej książki. "
        }
    ]

    },
    "invitation": {
        "header": "Wybierz kwotę (PLN) miesięcznego wsparcia:",
        "intro": "Wspierając projekt:",
        "content": [
            "Otrzymasz książkę jako jedna z pierwszych osób w Polsce",
            "Nazwiska osób, które wesprą projekt przed 20 listopada pojawią się w książce ",
            "Za minimum 60 zł miesięcznie otrzymasz od nas dodatkowo wyjątkowy plakat zaprojektowany przez Olę Jasionowską, Martę Frej lub Patryka Hardzieja (Ty wybierasz!)",
            "Współtworzysz z nami lepszą Polskę!"
        ]
    },
    "share": {
        "visible": true,
        "header": "Co nowego?",
        "intro": "",
        "tweets": [   "1572108878841626624","1583416309542289408","1583052921016815616","1583017092445454336","1582682776222203904", "1582677568775655429"]              
    },
    "pendingPage": {
        "intro": " Płatność jest w trakcie realizacji",
        "error_0": "Niestety Twoja płatność nie powiodła się.",
        "error_1": " Prosimy o ponowienie transakcji"
    },
    "thankyou": {
        "intro": "Tutaj krótkie podziękowanie dla osoby, która zdecydowała się na cykliczną wpłatę i… Huraa, otrzyma książkę!",
        "content": "Pochwal się, zachęć innych — w skrócie: udostępnij!"
    },
    "form": {
        "header_0": "Chcę dostać książkę!",
        "header_1": "Wydajmy razem książkę i wspólnie twórzmy lepszą Polskę!",
        "introPayment": "Hurra! Wspaniale, że chcesz razem z nami wydać książkę i tworzyć lepszą Polskę! ",
        "contentPayment": " Wysokość wybranego wsparcia wynosi",
        "contentPayment_1": " PLN.",
        "agreement_1": "Wyrażam zgodę na przetwarzanie przez Greenpeace Polska moich danych na potrzeby wsparcia projektu i prowadzonej kampanii ",
        "agreement_2": "Jeśli podajesz nam swój telefon, pamiętaj o zgodzie na kontakt telefoniczny :)",
        "agreement_3": "mailowo",
        "agreement_4": "telefonicznie (to są miłe telefony ;))",
        "agreement_5": "Wyrażam zgodę na kontakt ze strony Greenpeace Polska w sprawie moich płatności i kampanii:",
        "agreement_6": "Zgadzam się na zapisanie danych transakcji do kolejnych darowizn na rzecz akcji Greenpeace \"Przepisy na lepszą Polskę\" oraz akceptuję <a target=\"_blak\" href=\"https://poland.payu.com/wp-content/uploads/sites/14/2022/01/Regulamin-pojedynczej-transakcji-platniczej-PayU_2021_04-.pdf\">regulamin PayU</a>.",
        "introCard_1": "Wpisz dane",
        "introCard_2": "karty MasterCard lub Visa",
        "legalNotice_1": "Pamiętaj, że w dowolnym momencie możesz przerwać lub zawiesić adopcję regularną. Jeśli masz pytanie odnośnie transakcji, napisz do nas na adres",
        "legalNotice_2": "lub zadzwoń na numer",
        "legalNotice_3": "od wtorku do piątku w godz.10-15.",
        "legalNotice_4": "22 65 84 99",
        "legalNotice_5": "spl@greenpeace.org",
        "btn": "Wspieram"
    },

    "footer": {
        "header": "Podziel się rewolucyjnymi przepisami ze światem!",
        "address_1": "Fundacja Greenpeace Polska",
        "address_2": "Altowa 4<br/> 02-386 Warszawa",
        "mail": "info.poland@greenpeace.org",
        "phone": "+48 22 659 84 99",
        "shareText": "Stań się częścią naszej wspólnej historii i wesprzyj nas."
    }
}
